import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import BadgeEmblem, { BADGE_THEMES, badgeTheme } from "./BadgeEmblem";

export const BADGES_EVENT = "player-badges-updated";
let catalogPromise = null;
const loadCatalog = () => (catalogPromise ||= api.listBadges().catch(() => { catalogPromise = null; return { badges: [] }; }));
const ORDER = Object.keys(BADGE_THEMES);

// Granted badges grouped into three color-coded clusters (DNA / ON COURT / PHYSICAL). Live-syncs after inventory saves.
export default function PlayerBadges({ playerId, initial, className = "", size = 72 }) {
  const [badges, setBadges] = useState(initial || []);
  const [catMap, setCatMap] = useState({});

  useEffect(() => {
    loadCatalog().then(c => setCatMap(Object.fromEntries((c.badges || []).map(b => [b.name, b.category]))));
    if (!initial) api.getPlayerBadges(playerId).then(r => setBadges(r.badges || [])).catch(() => {});
    const onUpdate = (e) => { if (e.detail?.playerId === playerId) setBadges(e.detail.badges || []); };
    window.addEventListener(BADGES_EVENT, onUpdate);
    return () => window.removeEventListener(BADGES_EVENT, onUpdate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [playerId]);

  if (!badges.length) return null;
  const groups = ORDER.map(cat => ({ cat, items: badges.filter(b => (catMap[b] || "On Court") === cat) })).filter(g => g.items.length);
  let i = 0;
  return (
    <div className={`flex flex-wrap gap-x-8 gap-y-5 ${className}`} data-testid="player-badges">
      {groups.map(({ cat, items }) => {
        const t = badgeTheme(cat);
        return (
          <div key={cat} className="flex flex-col gap-2.5" data-testid={`player-badges-group-${cat.toLowerCase().replace(/\s+/g, "-")}`}>
            <div className="flex items-center gap-2">
              <span className="block w-6 h-px" style={{ background: t.color }} />
              <span className="text-[9px] uppercase tracking-[0.35em] font-bold" style={{ color: t.color }}>{t.label}</span>
              <span className="text-[9px] tabular-nums" style={{ color: `${t.color}88` }}>{items.length}</span>
            </div>
            <div className="flex flex-wrap gap-x-3 gap-y-4 pl-3 border-l" style={{ borderColor: `${t.color}33` }}>
              {items.map(b => (
                <div key={b} className="flex flex-col items-center text-center" style={{ width: size + 20, animation: `homeIn .5s ease ${(i++) * 60}ms both` }}
                  data-testid={`player-badge-${b.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                  <BadgeEmblem category={cat} size={size} />
                  <div className="mt-2 text-[9px] leading-[1.25] uppercase tracking-[0.15em] font-bold text-white">{b}</div>
                </div>
              ))}
            </div>
          </div>
        );
      })}
      <style>{`@keyframes homeIn { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: none; } }`}</style>
    </div>
  );
}
